export default "/images/logout.png?fefcbdfc5c2722e5b29aeecc177d69d1";